import { HeadSEO } from "../../components/SEO/HeadSEO";
import * as StyledLayout from "../../layouts/Styled.Layout";
import * as StyledTypography from "../../styles/Styled.Typography";
import * as StyledAbout from "./Styled.About";

export default function About() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Stanley Yeo",
    url: "https://stanleyyeo.com",
  };
  return (
    <>
      <HeadSEO
        siteTitle="About"
        siteDescription="Learn about Stanley Yeo, a Singapore freelance web designer crafting WordPress websites and brand identities for small businesses."
        structuredData={structuredData}
      />
      <StyledTypography.ParadoxSubtitle as="h2" data-animate="fade-up">
        Hello. Let’s pretend to be professional.
      </StyledTypography.ParadoxSubtitle>
      <StyledLayout.Grid>
        <StyledLayout.GridItem>
          <p data-animate="fade-up">
            It’s invariably a good idea to do a background check. Visiting this
            page has clearly ascertained your many levels of ingenuity. After
            all, trusting a random stranger with a website would be absurd. And
            it’s almost always not a good idea.
          </p>
          <p data-animate="fade-up">
            Before you rule out every word I say, it’s plausible to ponder what
            contributes to the basis of trust on an individual level. Perhaps,
            it could be interpreted as some awards-winning badges or trophies in
            your situation. It could also be academic certifications to prove my
            depth of knowledge. Best of all - maybe a random stranger endorsing
            another stranger sounds perfectly reasonable. I can’t define what’s
            acceptable in your case as different people have different opinions
            and expectations. If you’re looking for all those verifications, I’m
            afraid you’ll be utterly disappointed.
          </p>
          <p data-animate="fade-up">
            Of course, I don’t pretend I know how trust works. From what I’ve
            understood, trust is presumably about keeping to a promise. This
            page should vow to talk a little more about my backstory, and it’s
            as real as it gets, as far as I know. Though I’d love to chip in a
            few irrelevant instances sometimes, a promise is still a promise,
            yay?
          </p>
          <p data-animate="fade-up">
            Well, I’m an independent product designer (often called a freelance
            product designer) based in Singapore. You might hear of Singapore -
            both a tiny island and a country. If I can use a dish to describe
            Singapore, it would likely be Rojak (though I’m not sure of its
            origin). You probably tasted this dish if you’ve been to various
            parts of Southeast Asia before. Rojak is an eclectic coalesce of
            ingredients with a strong flavour that truly reflects Singapore’s
            diverseness - multicultural, multiracial, multilingual,
            multi-religious, etc. Should I say multifaceted in many other
            aspects as well? Perhaps that’s what it is and what makes it unique.
          </p>
          <p data-animate="fade-up">
            That’s the type of person I am. However, I’m nowhere near unique. In
            fact, I am just like the vast majority. Being an average person here
            means most of the things we’ve learned are relatively ‘Rojaked’. At
            least this is true for my case (I can’t vouch for the rest)
            involving a wide variety of topics. But whether or not these learned
            subjects are practical, from my observation, broad experiences would
            transpire more opportunities you wouldn’t otherwise have known, such
            as landing me in projects of all shapes and sizes, from traditional
            to digitising work. I can’t say I’m qualified to use the term
            multi-disciplinary creative. It is a broad term that remains a
            baffling mystery to me to this day, ever since I learned how to use
            Macromedia software.
          </p>
          <p data-animate="fade-up">
            If you’ve read this far, I assumed I have achieved little success in
            establishing some level of trust between you and me. I don’t know if
            you can call that trust, but I certainly can comprehend what trust
            is when it’s lost. That is, you’ll close this darn little tab in
            your browser. But that isn’t my goal.
          </p>
          <p data-animate="fade-up">
            Likewise, your goal isn’t just about knowing who I am, which I’m
            speculating, is you are more inclined to understand how my work will
            benefit you. Hence, getting acquainted is the first step. Studies
            show that it takes an estimated 50 hours for someone to be your
            casual friend. But before we even progress to be casual
            acquaintances, we gotta start somewhere, isn’t it?
          </p>
        </StyledLayout.GridItem>
        <StyledLayout.GridItem>
          <StyledAbout.OutlineWrapper data-animate="fade-up">
            <StyledAbout.OutlineContent as="article">
              <StyledAbout.OutlineTitle as="h3" data-animate="fade-up">
                Great. Where do I start?
              </StyledAbout.OutlineTitle>
              <ol>
                <li data-animate="fade-up">
                  <StyledTypography.StyledLink to="/newsletter/">
                    Sign up
                  </StyledTypography.StyledLink>{" "}
                  for my weekly(ish) newsletter.
                </li>
                <li data-animate="fade-up">
                  <StyledTypography.StyledLink to="/articles/">
                    Read articles
                  </StyledTypography.StyledLink>{" "}
                  on this website.
                </li>
                <li data-animate="fade-up">
                  If you like what you see. you might want to take a look at{" "}
                  <StyledTypography.StyledLink to="/resources/">
                    my toolbox
                  </StyledTypography.StyledLink>{" "}
                  or consider buying one of my products from{" "}
                  <StyledTypography.StyledLink
                    as="a"
                    href="https://stanleyyeo.gumroad.com/"
                  >
                    my shop
                  </StyledTypography.StyledLink>
                  .
                </li>
              </ol>
            </StyledAbout.OutlineContent>
          </StyledAbout.OutlineWrapper>
        </StyledLayout.GridItem>
      </StyledLayout.Grid>
    </>
  );
}
